import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback } from 'react';

import { useDisabledDatePresets } from '@/App/tiles/shared/useDisabledDatePresets.tsx';
import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import {
  selectTargetAccumulatorFirstFixing,
  selectTargetAccumulatorValidation,
} from '@/store/targetAccumulator/selectors.ts';

const FirstFixingDate = () => {
  const tileId = useTargetAccumulatorTileId();
  const { firstFixingDate, firstFixingTenor } = useAppSelector((state) =>
    selectTargetAccumulatorFirstFixing(state, tileId),
  );
  const currencyPair = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.currencyPair);
  const disabledDatePresets = useDisabledDatePresets(tileId, currencyPair);

  const validation = useAppSelector((state) => selectTargetAccumulatorValidation(state, tileId));

  const { sgwtWebAnalytics } = useSgwtWidgets();

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleDateChange = useCallback(
    (dateOrTenor: string) => {
      sgwtWebAnalytics?.trackEvent('TargetAccumulator', 'First Fixing Date changed', dateOrTenor);

      checkTargetAccumulatorWithTradeCapture({
        firstFixingDate: dateOrTenor,
      });
    },
    [checkTargetAccumulatorWithTradeCapture, sgwtWebAnalytics],
  );

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.firstFixingDate">
      <TradeCaptureValidationWrapper validation={validation?.firstFixingDate}>
        <DatePickerWithTenorNext
          date={firstFixingDate}
          tenor={firstFixingTenor}
          data-e2e="first-fixing-date-input"
          onChange={handleDateChange}
          disablePresets={disabledDatePresets}
        />
      </TradeCaptureValidationWrapper>
    </TargetAccumulatorFormField>
  );
};

export default FirstFixingDate;
